import { render, staticRenderFns } from "./guide-view-once.vue?vue&type=template&id=27c79b1a"
import script from "./guide-view-once.vue?vue&type=script&lang=js"
export * from "./guide-view-once.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports